























































































































































































































































































































































































































import { Country } from "@/shared/models/country";
import { Getter } from "vuex-class";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  eVisitorCityTaxPaymentCategoriesEnum,
  ReservationCheckInCustomerData,
} from "./CheckinTypes";
import { CityTaxCategory } from "@/shared/models/cityTaxCategory";
import { ArrivalOrganizationType } from "@/shared/models/arrivalOrganizationType";
import { Notification } from "@/store/modules/notifications";
import { ListModel } from "@/shared/models/listModel";
import { City } from "@/shared/models/city";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
  ReservationEVisitorCollapseExpandHideInfoEnum,
} from "@/shared/models/enums.type";
import {
  EVisitorFacility,
  EVisitorFacilityService,
} from "./eVisitorFacilityService";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";
import _ from "lodash";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { ArrivalReason } from "@/shared/models/arrivalReason";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";

@Component({ components: { DateField, TimeField } })
export default class CheckInGuestCard extends Vue {
  @Prop() allGuests?: ReservationCheckInCustomerData[];
  @Prop() guest?: ReservationCheckInCustomerData;
  @Prop() firstGuestOrganizationTypeId?: number | null;
  @Prop() eVisitorCheck?: boolean;
  @Prop() eVisitorFacilityService?: EVisitorFacilityService;
  @Prop() selectedPropertyId?: number;
  @Prop() accomodationUnitId?: number;
  @Prop() unitStatus?: string;

  @Getter("globalFilters/properties")
  allUserProperties?: GlobalFilterProperty[];

  @Getter("codebooks/identificationDocumentTypes")
  identificationDocumentTypes?: IdentificationDocumentType[];

  @Getter("codebooks/arrivalReasons")
  arrivalReasons?: ArrivalReason[];

  @Getter("appParams/reservationEVisitorCollapseExpandHideFacilityInfo")
  reservationEVisitorCollapseExpandHideFacilityInfo?: number;

  mounted() {
    if (this.guest) {
      this.loadCities(this.guest.city);
      if (!this.guest.isCheckedIn) {
        this.guest.eVisitorFacilityPropertyId = this.selectedPropertyId ?? null;
      }
    }
  }

  get renderFacilityInfo() {
    this.facilityOpen =
      this.reservationEVisitorCollapseExpandHideFacilityInfo ==
      ReservationEVisitorCollapseExpandHideInfoEnum.Expanded
        ? 0
        : -1;
    return this.reservationEVisitorCollapseExpandHideFacilityInfo !=
      ReservationEVisitorCollapseExpandHideInfoEnum.Hidden
      ? true
      : false;
  }

  get properties() {
    if (!this.allUserProperties) return [] as GlobalFilterProperty[];
    if (this.guest?.eVisitorIsCheckedIn || this.guest?.eVisitorIsCheckedOut) {
      return _.sortBy(this.allUserProperties, (x) => x.name);
    }
    return _.sortBy(
      this.allUserProperties?.filter((x) => x.status !== false),
      (x) => x.name
    );
  }

  eVisitorOpen = 0;
  facilityOpen = 0;

  eVisitorIntegrationEnum = EVisitorIntegrationEnum;
  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }
  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  eVisitStar(fieldName: string) {
    if (
      this.eVisitorCheck &&
      this.eVisitorIntegrationId !== EVisitorIntegrationEnum.None
    ) {
      if (this.eVisitorIntegrationId === EVisitorIntegrationEnum.HR) return "*";
      if (this.eVisitorIntegrationId === EVisitorIntegrationEnum.SL) {
        const required = [
          "genderId",
          "dateOfBirth",
          "countryOfResidenceId",
          "identificationDocumentTypeId",
          "identificationDocumentNumber",
          "eVisitorPaymentCategoryId",
          "checkInDate",
          "checkOutDate",
          "eVisitorCheckInTime",
          "eVisitorExpectedCheckoutTime",
          "propertyId",
          "eVisitorFacilityId",
        ];

        return required.includes(fieldName) ? "*" : "";
      }
    }

    return "";
  }

  @Watch("eVisitorOpen")
  eVisitorOpenChanged(fresh: number) {
    if (fresh == -1) {
      this.facilityOpen = -1;
    } else if (fresh == 0) {
      this.facilityOpen =
        this.reservationEVisitorCollapseExpandHideFacilityInfo ==
        ReservationEVisitorCollapseExpandHideInfoEnum.Expanded
          ? 0
          : -1;
    }
  }

  get sortedEVisitorFacilities() {
    return this.guest?.eVisitorFacilityPropertyId
      ? _.sortBy(
          this.eVisitorFacilities(this.guest.eVisitorFacilityPropertyId),
          (g) => (g.accountName ? g.accountName : g.facility)
        )
      : [];
  }

  @Watch("sortedEVisitorFacilities")
  sortedEVisitorFacilitiesChanged(fresh: EVisitorFacility[]) {
    if (fresh.length === 1 && this.guest) {
      this.guest.eVisitorFacilityId = fresh[0].id;
    } else if (this.accomodationUnitId && this.guest) {
      const defaultFacilities = fresh.filter((e) =>
        e.defaultForAccomodationUnitsIds.some(
          (u) => u === this.accomodationUnitId
        )
      );
      if (defaultFacilities.length === 1) {
        this.guest.eVisitorFacilityId = defaultFacilities[0].id;
      } else if (defaultFacilities.length === 0) {
        const activeFacilities = fresh.filter((f) => f.status === true);
        if (activeFacilities.length === 1) {
          this.guest.eVisitorFacilityId = activeFacilities[0].id;
        }
      }
    }
  }

  get facilityPropertyId() {
    return this.guest?.eVisitorFacilityPropertyId ?? null;
  }
  set facilityPropertyId(val: number | null) {
    if (this.guest) {
      if (this.guest.eVisitorFacilityPropertyId !== val) {
        this.guest.eVisitorFacilityPropertyId = val;
        this.guest.eVisitorFacilityId = null;
      }
    }
  }

  get isEmpty() {
    return this.guest?.isEmpty ?? true;
  }
  get isDirty() {
    return this.guest?.isDirty ?? false;
  }
  setDirty() {
    if (this.guest) {
      const alreadyDirty = this.guest.isDirty;

      this.guest.isDirty = true;
      this.guest.isEmpty = false;

      if (!alreadyDirty) {
        this.$emit("dirty");
      }
    }
  }

  numberOfFilledBeds(facility: EVisitorFacility) {
    const baseline = facility.numberOfCheckedInBeds;
    const selectedOnForm =
      this.allGuests?.filter(
        (x) => x.eVisitorFacilityId === facility.id && !x.eVisitorIsCheckedOut
      )?.length ?? 0;

    return baseline + selectedOnForm;
  }

  eVisitorFacilities(eVisitorFacilityPropertyId: number) {
    if (!eVisitorFacilityPropertyId) return [];

    if (this.eVisitorFacilityService) {
      if (
        !this.eVisitorFacilityService.groups.some(
          (x) => x.propertyId === eVisitorFacilityPropertyId
        )
      ) {
        this.eVisitorFacilityService.loadGroup(eVisitorFacilityPropertyId);
      }

      const group = this.eVisitorFacilityService.findGroup(
        eVisitorFacilityPropertyId
      )?.facilities;

      return group;
    }

    return [];
  }

  get eVisitorPaymentCategoryId() {
    return (
      this.guest?.getEffectiveEVisitorPaymentCategoryId(
        this.eVisitorIntegrationId
      ) ?? null
    );
  }
  set eVisitorPaymentCategoryId(val: number | null) {
    if (this.guest) {
      this.setDirty();
      this.guest.eVisitorPaymentCategoryId = val;
    }
  }

  get checkInDate() {
    return this.guest?.checkInDate ?? null;
  }
  set checkInDate(val: string | null) {
    if (this.guest) {
      this.setDirty();
      this.guest.checkInDate = this.guest.eVisitorCheckInDate = val ?? null;
    }
  }

  get checkOutDate() {
    return this.guest?.checkOutDate ?? null;
  }
  set checkOutDate(val: string | null) {
    if (this.guest) {
      this.setDirty();
      this.guest.checkOutDate = this.guest.eVisitorExpectedCheckoutDate =
        val ?? null;
    }
  }

  get eVisitorArrivalOrganizationTypeId() {
    return (
      this.guest?.eVisitorArrivalOrganizationTypeId ??
      this.firstGuestOrganizationTypeId ??
      null
    );
  }
  set eVisitorArrivalOrganizationTypeId(val: number | null) {
    if (this.guest) {
      this.setDirty();
      this.guest.eVisitorArrivalOrganizationTypeId = val;
      this.$emit("organizationTypeIdChanged", val);
    }
  }

  isCitiesLoading = false;
  citiesSearch = "" as string | null | undefined;
  cities = [] as City[];

  @Watch("citiesSearch")
  citiesSearchChanged(
    fresh: string | null | undefined,
    old: string | null | undefined
  ) {
    if (!fresh || fresh === "" || fresh === old) return;

    this.debouncedCitySearch(fresh);
  }

  debouncedCitySearch = _.debounce(this.loadCities, 500);

  async loadCities(search: string | null | undefined): Promise<City[]> {
    this.isCitiesLoading = true;

    return this.axios
      .get<ListModel<City>>("/codebooks/cities", {
        params: {
          name: search,
          $top: 50,
          $skip: 0,
          $orderBy: "name asc",
        },
      })
      .then(({ data }) => {
        this.cities = data.result;
        return this.cities;
      })
      .finally(() => {
        this.isCitiesLoading = false;
        this.setCTCategory();
      });
  }

  setCTCategory() {
    if (this.guest?.countryOfResidenceId === 1) {
      const selectedProperty = this.properties.find(
        (x) => x.propertyId == this.facilityPropertyId
      );
      if (selectedProperty) {
        const propertyCityName = selectedProperty.postalCodeAndCity
          .split(",")[1]
          .trim();
        if (propertyCityName === this.guest.city) {
          this.eVisitorPaymentCategoryId =
            eVisitorCityTaxPaymentCategoriesEnum.Lokalac;
        }
      }
    }
  }

  @Getter("language/language") language?: string;
  @Getter("codebooks/countries") _countries?: Country[];
  get countries() {
    const countriesList =
      this._countries?.map((x) => ({
        id: x.id,
        text: this.language === "hr-HR" ? x.name : x.englishName,
      })) ?? [];

    return _.sortBy(countriesList, (x) => x.text);
  }
  @Getter("codebooks/cityTaxCategories") cityTaxCategories?: CityTaxCategory[];
  @Getter("codebooks/arrivalOrganizationTypes")
  arrivalOrganizationTypes?: ArrivalOrganizationType[];

  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");
    const requiredIfDirty = (value: any) => {
      const r = required(value);
      return this.isDirty ? r : true;
    };
    const requiredIfEVisitor = (value: any) => {
      const r = required(value);
      return !this.isEmpty && this.eVisitorCheck ? r : true;
    };
    const maxLength = (max: number) => (value: string) =>
      !value ||
      value.length <= max ||
      this.$t("Validation.MaxLength", { count: max });

    const requiredGender = (value: number) => {
      //only male(1) or female(2) should be accepted for eVisitor
      if (value != 1 && value != 2) {
        value = 0;
      }
      const r = required(value);
      return this.eVisitorCheck ? r : true;
    };

    return {
      firstName: [requiredIfDirty, maxLength(50)],
      lastName: [requiredIfDirty, maxLength(50)],
      email: [
        maxLength(100),
        (value: string) =>
          !value ||
          /^$|.+@.+\..+/.test(value) ||
          this.$t("Validation.EmailFormat"),
      ],
      telephoneNumber: [maxLength(100)],
      city: [maxLength(50)],
      gender: [requiredGender],
      streetName: [maxLength(100)],
      houseNumber: [maxLength(10)],
      identificationDocumentNumber: [maxLength(50), requiredIfEVisitor],
      eVisitorRequired: [requiredIfEVisitor],
      eVisitorFacilityIdOnProperty: (selectedPropertyId: any) => (val: any) => {
        const shouldValidate =
          (this.isDirty || !this.isEmpty) && this.eVisitorCheck;
        const hasFacility = this.eVisitorFacilities(selectedPropertyId)?.some(
          (y) => y.id === val
        );

        return !shouldValidate || hasFacility;
      },
      dateTimesOrder: () => {
        // Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut
        if (this.guest) {
          const allAreSet =
            this.checkInDate &&
            this.guest.eVisitorCheckInTime &&
            this.checkOutDate &&
            this.guest.eVisitorExpectedCheckoutTime;

          if (!allAreSet) {
            // there is required validator for this cases
            return true;
          } else {
            const from =
              this.checkInDate?.substr(0, 10) +
              (this.guest.eVisitorCheckInTime ?? "00:00");
            const to =
              this.checkOutDate?.substr(0, 10) +
              (this.guest.eVisitorExpectedCheckoutTime ?? "00:00");

            return from > to
              ? this.$t(
                  "Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut"
                ).toString()
              : true;
          }
        }

        return true;
      },
    };
  }

  expandOnError(evt: boolean) {
    if (evt) {
      this.eVisitorOpen = 0; // 0 is the first(only) element
    }
  }

  reservationHolderFlagClicked(evt: MouseEvent) {
    this.setDirty();
    evt.stopPropagation();
    evt.preventDefault();
    this.$emit("reservation-holder-select");
  }

  deleteItem() {
    const name = `${this.guest?.firstName} ${this.guest?.lastName}`;
    const message =
      this.$t("DeleteConfirmation") +
      (name.trim().length > 0 ? " " + name : "");

    this.$store.dispatch("showNotification", {
      color: "warning",
      message,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.$emit("delete");
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
}
